import { css } from '@emotion/core'

export const control = css`
  &:disabled {
    background-color: transparent;
  }
`

export const buttonContainer = css`
  display: flex;
  justify-content: center;
`

export const signupButton = css`
  width: 50%;
`

export const smallerLabels = css`
  label {
    font-size: 11px;
  }
  
  input, select, textarea {
    font-size: 11px;
  }
`
